<template>
  <div
    class="block w-auto lg:fixed lg:w-5/6 z-50"
    :class="{
      'theme-dark': nightMode,
      navbar: !nightMode,
      'menu-open': showMenu && $isMobile(),
      'menu-hidden': !showMenu && nightMode,
      'menu-hidden-dark': !showMenu && !nightMode,
    }"
  >
    <div class="prenavbar flex justify-between items-center lg:hidden">
      <router-link to="/map" class="w-1/2 m-auto mx-4 my-4">
        <div>
          <img
            class="w-24"
            :src="require(`@/assets/urban-logo-dark.png`)"
            alt="logo"
          />
        </div>
      </router-link>
      <div class="w-1/3 m-auto mx-4 my-4">
        <img :src="require(`@/assets/logo-solar.png`)" alt="logo" />
      </div>
    </div>
    <nav class="flex items-center justify-between flex-wrap py-4 pr-4">
      <div class="flex items-center flex-shrink-0 mr-6 ml-4"></div>
      <div class="block lg:hidden">
        <button
          @click="showMenu = !showMenu"
          class="
            flex
            items-center
            px-3
            py-2
            border
            rounded
            text-black-200
            border-black
            hover:text-black
            hover:border-white
          "
          :class="{
            'border-black': nightMode,
            'border-white': !nightMode || showMenu == true,
          }"
        >
          <svg
            class="h-3 w-3"
            :class="{
              'fill-current text-white': !nightMode || showMenu == true,
              'fill-current text-black': nightMode,
            }"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <transition name="fade">
        <div
          v-if="showMenu"
          class="
            w-full
            block
            flex-start
            ml-4
            lg:hidden
            lg:flex
            lg:items-center
            lg:w-auto
          "
        >
          <!-- MODO MOVIL -->
          <div class="text-sm lg:flex-grow">
            <router-link
              v-for="page in pages"
              :key="page.id"
              class="
                block
                py-2
                mr-0
                hover:text-white
                lg:inline-block
                lg:mt-0
                lg:mr-4
                lg:hidden
              "
              :to="page.link"
              @click.native="showMenu = false"
              >{{ $t(`sidebar.menu.${page.name}`) }}</router-link
            >
            <router-link
              class="block mt-4 mr-4 lg:inline-block lg:mt-0 hover:text-white"
              to="/profile"
              @click.native="showMenu = false"
            >
              {{ $t("profile") }}
            </router-link>
            <div
              class="block my-4 mr-4 lg:inline-block lg:mt-0 hover:text-white"
            >
              <div class="mr-4 my-4 lg:mr-4 lg:mt-0 lg:mt-4">
                <toggle-button color="#000" v-model="nightMode" />
              </div>
            </div>

            <div
              class="
                w-full
                block
                py-2
                text-left
                select-none
                hover:text-white
                lg:inline-block
                lg:mt-0
              "
              @click="
                show();
                showMenu = false;
              "
            >
              {{ $t("logout") }}
            </div>
          </div>
          <div class="mt-4 lg:mt-0 lg:ml-4">
            <select
              class="border border-white"
              v-model="lang"
              @change="handleChange($event)"
              :class="{
                'navbar-select-dark': nightMode,
                navbar: !nightMode,
              }"
            >
              <option value="en">{{ $t("english") }}</option>
              <option value="ca">{{ $t("catalan") }}</option>
              <option value="es-ES">{{ $t("spanish") }}</option>
            </select>
          </div>
        </div>
      </transition>
      <!-- DESKTOP VERSION -->
      <div class="hidden items-center lg:flex">
        <div class="block mt-4 mr-4 lg:inline-block lg:mt-0 hover:text-white">
          <router-link to="/profile">
            <div class="w-8">
              <img :src="require(`@/assets/icon-user.png`)" />
            </div>
          </router-link>
        </div>
        <div class="block mt-4 mr-4 lg:inline-block lg:mt-0 hover:text-white">
          <toggle-button color="#000" v-model="nightMode" />
        </div>

        <div
          class="
            block
            mt-4
            border
            lg:inline-block
            lg:mt-0
            lg:mr-4
            lg:border-white
          "
        >
          <select
            v-model="lang"
            @change="handleChange($event)"
            :class="{
              'navbar-select-dark': nightMode,
              navbar: !nightMode,
            }"
          >
            <option value="en">{{ $t("english") }}</option>
            <option value="ca">{{ $t("catalan") }}</option>
            <option value="es">{{ $t("spanish") }}</option>
          </select>
        </div>
        <button
          class="block mt-4 lg:inline-block lg:mt-0 hover:text-white"
          @click="showLogoutModal()"
        >
          <div class="w-8">
            <img :src="require(`@/assets/icon-exit.png`)" />
          </div>
        </button>
      </div>
    </nav>
  </div>
</template>
<script>
/**
 * Componente Navbar
 * --------------------------------------------
 *
 * Componente que contiene 4 elementos, Perfil, un switch para cambiar a modo oscuro, un selector de idioma y un botón que abre un modal para hacer logout.
 *
 */
import ExitModal from "../components/modals/ExitModal.vue";
import { getProfile } from "@/utils/ProfileService.js";

export default {
  data() {
    return {
      nightMode: JSON.parse(sessionStorage.getItem("nightMode")) || false,
      showMenu: false,
      pages: [
        { link: "/map", name: "map", icon: "icon-map" },
        {
          link: "/dashboard",
          name: "dashboard",
          icon: "icon-dashboard",
        },
        { link: "/reports", name: "reports", icon: "icon-report" },
        { link: "/alarms", name: "alarms", icon: "icon-alarm" },
      ],
      lang: "",
      profile: {},
    };
  },
    /**
     *  Método que obtiene los datos del perfil para obtener el idioma que después se actualizará en el desplegable de idioams si existe. 
     * 
     */
  async beforeMount() {
    this.profile = await getProfile();
    this.getLanguage();
  },
  methods: {
    /**
     *  Método que al cambiar a otra opción se actualiza en el sessionStorage el idioma
     * 
     */
    handleChange(event) {
      sessionStorage.setItem("lang", event.target.value);
      this.lang = sessionStorage.getItem("lang");
    },
    /**
     *  Método que muestra un modal para poder hacer logout
     */
    showLogoutModal() {
      this.$modal.show(
        ExitModal,
        {},
        { width: 400, height: 150, adaptive: true }
      );
    },
    /**
     *  Método obtiene el idioma seleccionado.
     * Primero lo detecta del perfil del usuario, si no lo detecta de allí mira en el sessionStorage y por último lo obtiene del idioma del navegador.
     */
    getLanguage() {
      if (
        sessionStorage.getItem("lang") === null ||
        sessionStorage.getItem("lang") === ""
      ) {
        this.lang = this.profile.lang;
        sessionStorage.setItem("lang", this.profile.lang);
      } else {
        this.lang = sessionStorage.getItem("lang");
      }
    },
  },

  watch: {
    /**
     *  Actualiza y emite el estado de el modo oscuro cada vez que se cambia el valor en el switch, también actualiza el idioma y lo emite cuando se cambia del desplegable.
     */
    nightMode: function () {
      sessionStorage.setItem("nightMode", JSON.stringify(this.nightMode));
      this.$root.$emit("theme", this.nightMode);
    },
    lang: function () {
      this.$root.$on("currentLanguage", (currentLanguage) => {
        this.lang = currentLanguage;
      });
      this.$i18n.locale = this.lang;
    },
  },
  mount() {
    this.showLogoutModal();
  },
};
</script>
<style scoped>
.navbar {
  background-color: #121212;
  color: #68696d;
}
.menu-open {
  background-color: #2d2d2d;
  color: #ffffff;
}
.menu-hidden-dark {
  background-color: #121212;
  color: #68696d;
}
.menu-hidden {
  background: #ffffff;
  color: #68696d;
}
.navbar-select-dark {
  background-color: #ffffff;
  color: #2d2d2d;
  border: solid 1px black;
}

.router-link-active {
  opacity: 1;
  visibility: visible;
  border-left-color: #fbb03b;
  color: #fbb03b;
  transition: all 0.25s;
}

.fade-enter-active,
.fade-leave-active {
  transform: translateY(-4px);
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.prenavbar {
  background-color: #2d2d2d;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
}
</style>